import React, { Component, Fragment } from "react";
import ChannelBox from "./ChannelBox";
import ChatStartButton from "./ChatStartButton";
import ContactFormButton from "./ContactFormButton";
import InitialChannelFormDetails from "./InitialChannelFormDetails";
import TextBox from "./TextBox";
import CheckBox from "./CheckBox";
import RadioButton from "./RadioButton";
import DropDown from "./DropDown";

import "./InitialFormStyleSheet.css";

class InitialOfflinePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submittedForm: false,
    };
    this.items =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.channels
        ? this.props.config.channels.sort((i1, i2) => {
            return i1.selposition - i2.selposition;
          })
        : [];
    this.imageUrl =
      "data:image/png;base64,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";
    this.components = this.items.map((item) => {
      const ref = React.createRef();
      if (item.seltype === "checkBox") {
        return {
          item,
          ref,
          component: <CheckBox ref={ref} item={item} key={item.selposition} />,
        };
      } else if (item.seltype === "dropDown") {
        return {
          item,
          ref,
          component: <DropDown ref={ref} item={item} key={item.selposition} />,
        };
      } else if (item.seltype === "radioButton") {
        return {
          item,
          ref,
          component: (
            <RadioButton ref={ref} item={item} key={item.selposition} />
          ),
        };
      } /* 'txtBox' */ else {
        return {
          item,
          ref,
          component: <TextBox ref={ref} item={item} key={item.selposition} />,
        };
      }
    });
  }

  render() {
    // Sort form items by selposition.
    return (
      <Fragment>
        {!this.state.submittedForm ? (
          <>
            <div
              className="s360-initial-channel-container"
              style={this.containerStyle()}
            >
              <h4>{this.props.config.configDetails.offlineIntroText}</h4>
            </div>
            <div
              classname="offline-form-container"
              style={{
                width: "90%",
                minHeight: "10rem",
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                position: "relative",
                top: "-10%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "5%",
                }}
              >
                <label
                  style={{
                    marginBottom: "-0%",
                    fontSize: "small",
                    fontWeight: "400",
                    color: "#232649",
                  }}
                >
                  Name*
                </label>
                <input
                  style={{
                    all: "unset",
                    height: "4rem",
                    width: "95%",
                    border: "2px solid grey",
                    paddingLeft: "3%",
                    borderRadius: "3px",
                  }}
                  placeholder="Enter Name"
                ></input>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "5%",
                }}
              >
                <label
                  style={{
                    marginBottom: "-0%",
                    fontSize: "small",
                    fontWeight: "400",
                    color: "#232649",
                  }}
                >
                  Email*
                </label>
                <input
                  style={{
                    all: "unset",
                    height: "4rem",
                    width: "95%",
                    border: "2px solid grey",
                    paddingLeft: "3%",
                    borderRadius: "3px",
                  }}
                  placeholder="Enter Email"
                ></input>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "5%",
                }}
              >
                <label
                  style={{
                    marginBottom: "0%",
                    fontSize: "small",
                    fontWeight: "400",
                    color: "#232649",
                  }}
                >
                  Message
                </label>
                <textarea
                  style={{
                    all: "unset",
                    height: "6rem",
                    width: "95%",
                    border: "2px solid grey",
                    paddingLeft: "3%",
                    borderRadius: "3px",
                    paddingTop: "10%",
                  }}
                  placeholder="Enter Message"
                ></textarea>
              </div>
            </div>

            <div className={"s360-initial-form-start-button-container"}>
              <button
             
                className="s360-initial-form-start-button"
                onClick={this.submitForm}
                style={this.buttonStyle()}
              >
                <span class="s360-initial-form-start-button-span-text">
                  {this.props.config.designDetails.contactFormButtonText}
                </span>
              </button>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                padding: "10%",
                flexDirection: "column",
              }}
            >
              <h2 style={{ marginBottom: "-8%", color: "#E43746" }}>Thanks,</h2>
              <h2 style={{ color: "#262257" }}>we will get back soon...</h2>
            </div>
          </>
        )}
      </Fragment>
    );
  }

  submitForm = () => {
    this.setState({ submittedForm: true });
  };

  containerStyle = () => {
    return {
      backgroundColor: this.props.config.designDetails.pageBackgroundColor,
    };
  };

  buttonStyle = () => {
    return {
      background: this.props.config.designDetails.formButtonBackground,
      color: this.props.config.designDetails.formButtonColor,
      fontFamily: this.props.config.designDetails.selectionButtonFont,
      fontSize: this.props.config.designDetails.selectionButtonFontSize + "px",
    };
  };

  startChat = () => {
    // TODO: Add validations for fields.
   
    let invalidOptions = this.components.filter((component) => {
      return !component.ref.current.validate();
    });
    const isValid = invalidOptions.length === 0;
    if (isValid) {
      let params = {};
      this.components.forEach(
        (component) =>
          (params = { ...params, ...component.ref.current.value() })
      );
      this.props.actions.startChat(params);
    } else if (invalidOptions.length > 0) {
      let errorMessage = invalidOptions[0].ref.current.validationErrorMessage();
      this.props.actions.showPopUpMessage(errorMessage);
      invalidOptions[0].ref.current.focus = true;
    }
  };
}
export default InitialOfflinePage;
